import { usePullToRefresh } from '@/hooks/use-pull-to-refresh';
import BasketballLoader from './BasketballLoader';
import { cn } from '@/lib/utils';

interface PullToRefreshProps {
  eventName: string;
}

/**
 * Renders a pull-to-refresh affordance at the top of a page.
 * Dispatches `eventName` (e.g. `feed-refresh`) when user pulls past threshold.
 */
const PullToRefresh = ({ eventName }: PullToRefreshProps) => {
  const { pull, refreshing, progress } = usePullToRefresh(eventName);
  const visible = pull > 4 || refreshing;
  const height = refreshing ? 56 : Math.min(pull, 70);

  return (
    <div
      style={{ height }}
      className={cn(
        'flex items-center justify-center overflow-hidden transition-[height] duration-200 ease-out',
      )}
    >
      {visible && (
        <div
          className="flex items-center justify-center"
          style={{
            opacity: refreshing ? 1 : Math.min(1, progress),
            transform: refreshing ? undefined : `rotate(${progress * 180}deg)`,
            transition: 'opacity 150ms ease-out',
          }}
        >
          <BasketballLoader size={24} />
        </div>
      )}
    </div>
  );
};

export default PullToRefresh;
